"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _ReduxFormPhoneNumber = _interopRequireDefault(require("./ReduxFormPhoneNumber"));
var _ReduxFormFieldComponent = require("./ReduxFormFieldComponent");
var ReduxForm = {
  createFieldComponent: _ReduxFormFieldComponent.createFieldComponent,
  FieldComponent: _ReduxFormFieldComponent.FieldComponent,
  PhoneNumber: _ReduxFormPhoneNumber["default"]
};
ReduxForm.Input = function (_ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, (0, _extends2["default"])({
    component: _ReduxFormFieldComponent.FieldComponent
  }, props));
};
var _default = exports["default"] = ReduxForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/ReduxForm.js
// module id = 276
// module chunks = 25